













































































































































import { Component, Vue } from "vue-property-decorator";
import uploads from "@/components/uploads.vue";
import api from "@/api";
import {imageUrl} from '@/utils/common'
import Tinymce from '@/components/Tinymce/index.vue'
import {quillEditor} from 'vue-quill-editor' //调用编辑器
// import Quill from 'quill'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

import ImageResize from 'quill-image-resize-module';
import * as Quill from "quill";

Quill.register('modules/imageResize', ImageResize);

@Component({
  components: {
    quillEditor,
    Tinymce,
    uploads

  }
})
export default class Commodity extends Vue {
  loading = false
  fenlei = ''
  xuni = '1'
  shoumai: any = '1'
  guige = ''
  shopForm: any = {
    payMethod: []
  }
  images: any = []
  config = {}
  productText = ''
  editorOptionMS = {
    placeholder: '请输入',
    modules: {
      imageResize: {
        displayStyles: {
          backgroundColor: 'black',
          border: 'none',
          color: 'white'
        },
        modules: ['Resize', 'DisplaySize', 'Toolbar']
      },
      toolbar: [
        [{'size': ['small', false, 'large', 'huge']}], // 字体大小
        [{'font': []}], // 字体
      ]
    }
  };
  editorOption = {
    placeholder: '请输入',
    modules: {
      imageResize: {
        displayStyles: {
          backgroundColor: 'black',
          border: 'none',
          color: 'white'
        },
        modules: ['Resize', 'DisplaySize', 'Toolbar']
      },
      toolbar: [
        ['bold', 'italic', 'underline', 'strike'], //  加粗、倾斜、下划线、删除线
        ['blockquote', 'code-block'],// 引用代码块
        // [{'header': 1}, {'header': 2}], // 标题，键值对应的形式，1，2 表示字体大小
        [{'list': 'ordered'}, {'list': 'bullet'}], // 列表
        [{'script': 'sub'}, {'script': 'super'}], // 上下标
        [{'indent': -1}, {'indent': +1}], // 缩进
        [{'direction': 'rtl'}], // 文本方向
        [{'size': ['small', false, 'large', 'huge']}], // 字体大小
        [{'header': [1, 2, 3, 4, 5, 6, false]}], // 几级标题
        [{'color': []}, {'background': []}], // 字体颜色，字体背景颜色
        [{'font': []}], // 字体
        [{'align': []}], // 对齐方式
        ['image'], // 图片上传
        ['clean'], //清除
      ]
    }
  };

  fileList = {
      image_name: '', image_url: ''
    }
  model: any = {
    OSSAccessKeyId: "",
    signature: "",
    policy: "",
    key: "",
    callback: "",
    file: "",
    success_action_status: ''
  };
  baseUrl = imageUrl
  getData(item: any) {
    this.images.push(this.baseUrl + item)
  }

  delPro(key: any) {
    this.images.splice(key, 1)
  }


  getConfig() {
    api.getJavaConfig().then((res) => {
      this.config = res;
    });
  }

  xuniList = []
  getXuNiShop() {
    api.post('J27718', {}).then(res => {
      this.xuniList = res.list
    })
  }

  id: any =''
  activated() {
    this.shopForm = {payMethod: []}
    this.images = []
    this.id = ''

    let { id } = this.$route.query
    if(id) {
      this.id = id
      this.getDetail()
    }
    this.getConfig()
    this.getXuNiShop()
  }

  getDetail() {
    api.post('J27715', {id: this.id}).then(res=> {
      this.shopForm = res
      this.shopForm.payMethod = this.shopForm.payMethod.split(',')

      if(this.shopForm.cardCount >= 2) {
        this.shoumai = '2'
      }

      if(res.mainImage) {
        this.images = JSON.parse(res.mainImage)
      }
    })
  }

  mounted() {
    // 初始化所有 quill 编辑器
    const editors = ['quillEditor1', 'quillEditor2', 'quillEditor3']
    editors.forEach(ref => {
      const quill = this.$refs[ref] as any
      if (quill) {
        const editor = quill.quill
        // 重写图片上传处理
        const toolbar = editor.getModule('toolbar')
        toolbar.addHandler('image', () => {
          this.uploadImage(ref)
        })

         // 1. 先禁用它，阻止自动聚焦
        editor.enable(false);

        // 2. 使用 nextTick 等待 DOM 更新完成
        setTimeout(() => {
          // 3. 重新启用编辑器
          editor.enable(true);
          // 4. 强制移除焦点
          editor.blur();
        }, 1000);
      }
    })
  }

  uploadImage(editorRef: string) {
    const input = document.createElement('input')
    input.setAttribute('type', 'file')
    input.setAttribute('accept', 'image/*')
    input.onchange = (e: any) => {
      const file = e.target.files[0]
      if (file) {
        this.handleImageUpload(file, editorRef)
      }
    }
    input.click()
  }

  handleImageUpload(file: File, editorRef: string) {
    const isJPG = file.type === "image/jpeg" || file.type === "image/png"
    const isLt2M = file.size / 1024 / 1024 < 2
    if (!isJPG) {
      this.$message.error("上传图片只能是 JPG/PNG 格式!")
      return
    }
    if (!isLt2M) {
      this.$message.error("上传图片大小不能超过 2MB!")
      return
    }

    // 调用 J27501 接口上传图片
    api
      .post("J27501", {
        fileName: file.name,
        softLink: ''
      })
      .then((data: any) => {
        const formData = new FormData()
        
        Object.keys(data).forEach(key => {
          formData.append(key, data[key])
        })
        formData.append('file', file)

        fetch(imageUrl, {
          method: 'POST',
          body: formData
        })
          .then(response => response.json())
          .then((res: any) => {
            if (res.errcode == 0) {
              const quill = this.$refs[editorRef] as any
              if (quill) {
                const editor = quill.quill
                const range = editor.getSelection()
                if (range) {
                  const imgUrl = imageUrl + res.data
                  // 插入图片
                  editor.insertEmbed(range.index, 'image', imgUrl)
                  // 为插入的图片添加自定义 class
                  setTimeout(() => {
                    // 使用 setTimeout 确保 DOM 已经更新
                    const imageBlot = editor.getLeaf(range.index + 1)[0]
                    if (imageBlot && imageBlot.domNode) {
                      imageBlot.domNode.classList.add('custom-quill-image')
                      console.log('已为图片添加 custom-quill-image 类', editorRef)
                    } else {
                      // 如果直接获取失败，尝试遍历所有图片元素
                      const imgElements = editor.container.querySelectorAll('img')
                      if (imgElements.length > 0) {
                        const lastImg = imgElements[imgElements.length - 1]
                        lastImg.classList.add('custom-quill-image')
                        console.log('通过遍历为最后一张图片添加 custom-quill-image 类', editorRef)
                      }
                    }
                  }, 100)
                }
              }
            } else {
              this.$message.error('上传失败')
            }
          })
          .catch(() => {
            this.$message.error('上传失败')
          })
      })
      .catch(() => {
        this.$message.error('上传失败')
      })
  }

  onSubmit() {
    if(!this.shopForm.productName) {
      this.$message.warning('请输入商品名称')
      return
    }
    if(!this.shopForm.productCategory) {
      this.$message.warning('请选择商品分类')
      return
    }
    if(this.shoumai == 2) {
      if(!this.shopForm.cardCount) {
        this.$message.warning('请输入组合个数')
        return
      }
      if(parseInt(this.shopForm.cardCount) < 2) {
        this.$message.warning('组合个数最小值为2')
        return
      }
    }
    if(this.images.length == 0) {
      this.$message.warning('请上传商品主图')
      return
    }
    if(!this.shopForm.productSpec) {
      this.$message.warning('请选择商品规格')
      return
    }
    if(!this.shopForm.price) {
      this.$message.warning('请输入商品售价')
      return
    }
    if(parseFloat(this.shopForm.price) <= 0) {
      this.$message.warning('商品售价不能为0')
      return
    }
    if(!this.shopForm.stock) {
      this.$message.warning('请输入库存')
      return
    }
    if(parseInt(this.shopForm.stock) <= 0) {
      this.$message.warning('库存不能为0')
      return
    }
    if(!this.shopForm.payMethod) {
      this.$message.warning('请选择支付方式')
      return
    }
    if(this.shopForm.integralDeduction === '') {
      this.$message.warning('请选择积分抵扣')
      return
    }
    // 验证商品原价大于商品售价
    if(this.shopForm.originalPrice && this.shopForm.price) {
      const originalPrice = parseFloat(this.shopForm.originalPrice)
      const price = parseFloat(this.shopForm.price)
      if(originalPrice <= price) {
        this.$message.warning('商品原价必须大于商品售价')
        return
      }
    }
    if(this.shoumai == 1) {
      this.shopForm.cardCount = 1
    }
    
    // 检查并添加 custom-quill-image 类名到 productDetail 中的 img 标签
    if(this.shopForm.productDetail) {
      // 创建临时 DOM 元素来处理 HTML
      const tempDiv = document.createElement('div')
      tempDiv.innerHTML = this.shopForm.productDetail
      
      // 查找所有 img 标签
      const imgElements = tempDiv.querySelectorAll('img')
      imgElements.forEach(img => {
        // 检查是否已经有 custom-quill-image 类
        if(!img.classList.contains('custom-quill-image')) {
          img.classList.add('custom-quill-image')
        }
      })
      
      // 更新 productDetail 字段
      this.shopForm.productDetail = tempDiv.innerHTML
    }
    
    this.shopForm.mainImage = JSON.stringify(this.images)
    console.log('this.images', this.images)
    this.loading = true
    let apiUrl = this.id ? 'J27720' : 'J27713'
    api.post(apiUrl, {...this.shopForm, payMethod: this.shopForm.payMethod.toString()}).then(res => {
      this.$message.success('操作成功')
      this.$router.back()
    }).finally(() => {
      this.loading = false
    })
  }
  back() {
    this.$router.back()
  }
}
